import { createFeature, createReducer, on } from '@ngrx/store';
import { CommSchemeSetupCreateDto } from '@shared/data-access/dto';
import { CommSchemeSetupModel } from '@shared/data-access/models';
import { CommSchemeSetupAction } from '../actions';

export const featureName = 'commSchemeSetup';

export interface CommSchemeSetupState {
  item: CommSchemeSetupModel | null;
  submittingStatus: {
    success: boolean;
    loading: boolean;
    error: any;
  };
}

export const initialState: CommSchemeSetupState = {
  item: null,
  submittingStatus: {
    success: false,
    loading: false,
    error: null,
  },
};

export const CommSchemeSetupFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(CommSchemeSetupAction.setItemDetail, (state, { item }) => ({
      ...state,
      item,
    })),
    on(CommSchemeSetupAction.updateItemDetail, (state, { data }) => ({
      ...state,
      item: CommSchemeSetupModel.merge(state.item ?? CommSchemeSetupModel.createEmpty(), data, {
        enableImplicitConversion: true,
      }),
    }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = CommSchemeSetupFeature;
